import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setPageTitle, setUserData } from "../../app/features/DataSlice";
import bgGold from "../../assets/images/bg-gold.jpg";
import { useGetProfileQuery } from "../../app/features/apiSlice";
import Loader from "../../components/Loader";
import Error from "../../components/Error";
import { Link, useParams } from "react-router-dom";
import CurrencyValue from "../../components/CurrencyValue";
// import UpdateInitialIngot from "../../components/UpdateInitialIngot";
import moment from "moment";

const ClientDashboard = () => {
  const dispath = useDispatch();
  const { t } = useTranslation();
  const { lang } = useParams();
  const sessionId = useRef(Date.now()).current;
  const dispatch = useDispatch();
  const [currPlan, setCurrPlan] = useState({});
  const [currHOnePlan, setCurrHOnePlan] = useState({});
  const { data, isSuccess, isLoading, isError, error } = useGetProfileQuery({
    sessionId,
  });

  useEffect(() => {
    if (isSuccess) {
      const user = {
        ...data?.user,
        type: data?.orgUser.type,
        company: data?.orgUser.company_name,
      };
      dispatch(setUserData(user));
      const plans = data?.plan;
      const hOnePlans = data?.heliorOne;
      if (plans.length > 0) {
        setCurrPlan(plans[0]);
      }
      if (hOnePlans.length > 0) {
        setCurrHOnePlan(hOnePlans[0]);
      }
    }
    // eslint-disable-next-line
  }, [isSuccess, data]);

  useEffect(() => {
    dispath(setPageTitle("Dashboard"));
  });

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;

  return (
    <div className="my-3">
      {isSuccess && (
        <>
          {data.orgUser?.type === "COMPANY" ? (
            <>
              <h4 className="heading mb-3 text-capitalize">
                {t("welcome")} {data.orgUser?.company_name}
              </h4>
            </>
          ) : (
            <h4 className="heading mb-3 text-capitalize">
              {t("welcome")} {data?.user?.first_name} {data?.user?.last_name}
            </h4>
          )}
          {currHOnePlan?.contract_date && (
            <Card className="mb-3 p-3" bg="dark1">
              <Card.Title className="d-flex justify-content-between align-items-center">
                <div className="text-gold">XOne®</div>

                <Link
                  to={`/${lang}/plan/excelior-one/${currHOnePlan.contract_code}`}
                  className="btn btn-primary-outline"
                >
                  {t("seeAllData")}
                </Link>
              </Card.Title>

              <Card.Body className="px-0 py-4">
                <ul className="p-0 list-unstyled xone-details-list">

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("contractDate")}</span>
                    <span className="text-end">
                      {currHOnePlan?.contract_date
                        ? moment(currHOnePlan.contract_date).format("DD-MM-YYYY")
                        : ""}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("contractNumber")}</span>
                    <span className="text-end">{currHOnePlan.contract_code}</span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("durationOfHousing")}</span>
                    <span className="text-end">
                      {currHOnePlan.duration} {t("years")}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("gramsPurchased")}</span>
                    <span className="text-end">
                      {currHOnePlan.total_gr || 0}gr
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("totalPayment")}</span>
                    <span className="text-end">
                      <CurrencyValue
                        amount={currHOnePlan.total_payment}
                        currency={currHOnePlan.currency}
                        rate={currHOnePlan.exchange_rate}
                      />
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("totalGuarantee")}</span>
                    <span className="text-end">
                      <CurrencyValue
                        amount={currHOnePlan.total_payment_with_margin}
                        currency={currHOnePlan.currency}
                        rate={currHOnePlan.exchange_rate}
                      />
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("totalBankTransfer")}</span>
                    <span className="text-end">
                      <CurrencyValue
                        amount={currHOnePlan.bankTransfer}
                        currency={currHOnePlan.currency}
                        rate={currHOnePlan.exchange_rate}
                      />
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("status")}</span>
                    <span className="text-end flex-shrink-0">
                      <Badge
                        bg={currHOnePlan.status === "Active" ? "gold" : "danger"}
                      >
                        {currHOnePlan?.status === "Active"
                          ? t("active")
                          : t("inactive")}
                      </Badge>
                    </span>
                  </li>

                </ul>
              </Card.Body>
            </Card>
          )}

          {currPlan?.contract_code ? (
            <Card className="mb-3 p-3" bg="dark1">
              <Card.Title className="d-flex justify-content-between align-items-center">
                <div className="text-gold">XPlan®</div>

                <Link
                  to={`/${lang}/plan/excelior-plan/${currPlan?.contract_code}`}
                  className="btn btn-primary-outline"
                >
                  {t("seeAllData")}
                </Link>
              </Card.Title>

              <Card.Body className="px-0 py-4">
                <ul className="p-0 list-unstyled xplan-details-list">

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("contractDate")}</span>
                    <span className="text-end">
                      {currPlan?.contract_date
                        ? moment(currPlan.contract_date).format("DD-MM-YYYY")
                        : ""}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("contractNumber")}</span>
                    <span className="text-end">
                      {currPlan?.contract_code}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("periodicity")}</span>
                    <span className="text-end">
                      {t(`${currPlan?.periodicity_of_amount}`)}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("totalPayment")}</span>
                    <span className="text-end">
                      <CurrencyValue
                        amount={currPlan?.recurring_amount_paid}
                        currency={currPlan?.currency}
                        rate={currPlan?.fx_rate}
                      />
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("docFeePaid")}</span>
                    <span className="text-end">
                      <CurrencyValue
                        amount={currPlan?.doc_share}
                        currency={currPlan?.currency}
                        rate={currPlan?.fx_rate}
                      />
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("numberOfRecurringInstallments")}</span>
                    <span className="text-end">
                      {currPlan?.number_of_recurring_payments}
                    </span>
                  </li>

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("ingotCutting")}</span>
                    <span className="text-end">
                      {currPlan?.ingot_gr} gr
                    </span>
                  </li>

                  {currPlan?.docSplitRequest && (
                    <li className="d-flex justify-content-between align-items-start mb-3">
                      <span>{t("docSplitStatus")}</span>
                      <span className="text-end">
                        {t(`${currPlan?.docSplitRequest}`)}
                      </span>
                    </li>
                  )}

                  <li className="d-flex justify-content-between align-items-start mb-3">
                    <span>{t("status")}</span>
                    <span className="text-end flex-shrink-0">
                      <Badge
                        bg={currPlan?.status === "Active" ? "gold" : "danger"}
                      >
                        {currPlan?.status === "Active"
                          ? t("active")
                          : t("inactive")}
                      </Badge>
                    </span>
                  </li>

                </ul>
              </Card.Body>
            </Card>
          ) : (
            <Card className="bg-dark text-white">
              <Card.Img src={bgGold} alt="Card image" />
              <Card.ImgOverlay className="d-flex flex-column justify-content-center align-items-center">
                <Card.Title>{t("buyNewPlan")}</Card.Title>
                <Card.Text>{t("accessProductsArea")}</Card.Text>
                <Link
                  to={`/${lang}/products`}
                  className="text-light mt-3 btn btn-primary-outline lh-sm"
                >
                  {t("discoverAllProducts")}
                </Link>
              </Card.ImgOverlay>
            </Card>
          )}
        </>
      )}
    </div>
  );
};

export default ClientDashboard;
